import type { IconName } from '@launchpad-ui/icons';
import { Icon } from '@launchpad-ui/icons';
import cx from 'clsx';

import { InstructionListChangeKind } from './instructionListUtils';

import styles from './styles.module.css';

const instructionListIcons: { [key in InstructionListChangeKind]: IconName | undefined } = {
  [InstructionListChangeKind.CHANGE]: 'change-history',
  [InstructionListChangeKind.ADD]: 'add',
  [InstructionListChangeKind.REMOVE]: 'minus',
  [InstructionListChangeKind.REORDER]: 'swap-vertical',
  [InstructionListChangeKind.DEFAULT]: undefined,
  [InstructionListChangeKind.NONE]: undefined,
  [InstructionListChangeKind.DECIMAL]: undefined,
};

type FlagStatusIconProps = {
  changeKind: InstructionListChangeKind;
  className?: string;
  testId?: string;
};

export function InstructionListItemIcon({ changeKind, className, testId }: FlagStatusIconProps) {
  const name = instructionListIcons[changeKind] as IconName;
  if (name) {
    return (
      <Icon
        name={name}
        data-test-id={testId}
        size="small"
        className={cx(
          styles[`instructionListItemIcon${changeKind.charAt(0).toUpperCase() + changeKind.slice(1)}`],
          styles.InstructionListItemIcon,
          className,
        )}
      />
    );
  }
  return <></>;
}
